import React, { useContext, useState } from 'react';
import { Card, Radio, Timeline, Tag, Row, Col, Pagination, Image, Badge, Button, Segmented } from 'antd';
import { useTranslation } from 'react-i18next';
import { useFetch } from '../../../../hooks/useFetch/useFetch';
import { useAuth } from '../../../../store/AuthContext/AuthContext';
import { ClockCircleFilled} from '@ant-design/icons';
import '../../pages.scss';
import { Synchronized } from '../../../components/design/Synchronized/Synchronized';
import { SCHEDULEDJOB } from '../../../../common/constants/services';
import TableLZM from '../../../components/design/table/TableLZM';
import moment from 'moment';
import { ExpandableText } from '../../../../common/utils/ExpandableText';
import { POSTTYPES } from '../../../../common/constants/postTypes';
import { PostSheduledDrawer } from './PostSheduledDrawer';
import { DrawerContext } from '../../../../store/DrawerContext/DrawerContext';
import { CTA_TYPE, SCHEDULE_STATUS } from '../../../../common/constants/postsConstants';
import { PageTitle } from '../../common/PageTitle';
import { PageFilters, PageFilterField } from '../../common/PageFilters';
import { EmptyStateBox } from '../../../components/design/EmptyStateBox/EmptyStateBox';

export const GooglePostsScheduled = () => {

	const [refreshPosts, setRefreshPosts] = useState(false);
	const { projectGroup } = useAuth();
	const [scheduled, setScheduled] = useState([]);
	const [postScheduledSelected, setPostScheduledSelected] = useState(null);
	const [filterStatus, setFilterStatus] = useState('SCHEDULED');
	const [isLoading, setIsLoading] = useState(false);
	const { setLogsDrawer } = useContext(DrawerContext)
	//const {updateGlobalImage , setUpdateGlobalImage} = useContext(GlobalVariableContext)
	const { t } = useTranslation();

	useFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/${projectGroup.group}/postsScheduled?status=${filterStatus}`, {}, [refreshPosts],
		(data) => {			
			setScheduled(data);			
	});
	
	const columns = [	  
	  {
		title: 'Foto',
		key: 'summary',
		align:'center',
		width: '200px',		
		render: (record: any) => (
			<>
				{record.post.photosURL.length > 0 ? 
					<Image
						width={200}
						style={{borderRadius:'20px'}}						
						src={record.post.photosURL[0]}
					/>
					:
					<h2 style={{width:'200px', height:'200px', border:'.5px solid silver', margin:'0px', borderRadius: '20px', color:'silver', background:'GhostWhite', display:'flex', alignItems: 'center', justifyContent: 'center'}}>Sin foto</h2>
				}
			</>
		)
	  },
	  {
		  title: 'Detalle',
		  key: 'summary',		
		  render: (record: any) => (
			  <div><ExpandableText text={record.post.summary}></ExpandableText></div>
			  )
		},		
		{
			title: '',
			width: '400px',
			key: 'local',
			render: (record: any) => (
				<Card bodyStyle={{ background: 'white', borderRadius: '20px' }}>
					<div style={{ display: 'flex', justifyContent: 'space-between', color: SCHEDULE_STATUS[record.status].color }}>						
						<b><ClockCircleFilled/> {moment(record.scheduledDate).format('ll')}</b>																						
						<Tag style={{ borderRadius: '20px' }}>{POSTTYPES[record.post.type]}</Tag>
					</div>
					<div>
						{
							record.scope === 'LOCATION' ? 
								<h3 style={{color:'LightSlateGray'}}>{record.locationTitle}</h3>
								:
								<h3 style={{color:'LightSlateGray'}}>En {record.locationIds.length} locales</h3>
						}
						{record.post?.callToActionType &&
							<Tag color='geekblue' icon={React.createElement(CTA_TYPE[record.post?.callToActionType].icon)}>{CTA_TYPE[record.post?.callToActionType].name}</Tag>							
						}			
					</div>
										
					
					<div style={{ marginTop:'20px', display: 'flex', justifyContent: 'right', fontWeight: 'bold' }}>						
						<a onClick={() => { setPostScheduledSelected(record) }}>VER DETALLE {'>>>'}</a>
					</div>
				</Card>
			)
		}
	]
	
	return (
		<Card className='main-card-content'>
			
			<div style= {{width:'100%', display:'flex', justifyContent:'space-between'}}>
				<PageTitle
					title='Calendario de Programaciones'
					pageInfo='Revisa y gestiona las publicaciones programadas: pendientes, publicadas y errores de ejecución. Puedes gestionar en la pantalla de alertas que se envíe un email el día que se hace el lanzamiento.'
					extra={
						<Button type='link' onClick={() => setLogsDrawer(true)}>
							Ver Registro
						</Button>
					}
				/>
			</div>			

			<Synchronized service={[SCHEDULEDJOB.GBP_POSTS]}/>	

			<div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
				<PageFilters>
					<PageFilterField label='Estado' active={filterStatus !== 'SCHEDULED'}>
						<Segmented
							value={filterStatus}
							size='small'
							options={[
								{ label: 'Pendientes', value: 'SCHEDULED' },
								{ label: 'Publicadas', value: 'LAUNCHED' },
								{ label: 'Errores', value: 'ERROR' },
							]}
							onChange={(value: any) => { setIsLoading(true); setFilterStatus(value); }}
						/>
					</PageFilterField>
				</PageFilters>
			</div>

			<div style={{ margin: '20px' }}>
				{!scheduled?.length ? (
					<EmptyStateBox
						icon={<ClockCircleFilled />}
						title="No hay programaciones"
						description="Cuando programes publicaciones aparecerán en este listado."
					/>
				) : (
					<TableLZM rowKey={'name'} columns={columns} dataSource={scheduled} loading={false} showHeader={false}/>
				)}
			</div>			
			
			{postScheduledSelected && 
				<PostSheduledDrawer 
					postScheduled={postScheduledSelected} 
					onFinish={() => {setPostScheduledSelected(null)}}
					onChange={() => {console.log('refreshPosts'); setPostScheduledSelected(null); setRefreshPosts(!refreshPosts)}} />
			}			
		</Card>
	)
}